import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { reload } from '@src/utils';
import { StorageKeys } from '@src/constants/storage';
import { APP_CONFIG, Language } from '@src/core';
import { StorageService } from '@src/app/modules/auth';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcherComponent {
  private readonly translateService = inject(TranslateService);
  private readonly storageService = inject(StorageService);

  languageCodes: Language[] = APP_CONFIG.localizations;

  getLanguage(code: Language): string {
    switch (code) {
      case Language.RU:
        return this.translateService.instant('components.languageSwitcher.labels.ru');

      case Language.EN:
        return this.translateService.instant('components.languageSwitcher.labels.en');

      default:
        return this.translateService.instant('components.languageSwitcher.labels.ru');
    }
  }

  isSelected(code: Language): boolean {
    return this.translateService.currentLang === code;
  }

  selectLanguage(code: Language) {
    this.storageService.setItem(StorageKeys.Locale, code);
    this.translateService.use(code);

    // TODO: убрать после исправления ошибки #9372
    if (this.translateService.currentLang !== code) {
      reload();
    }
  }
}
